<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/o2o-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">全渠道购物场景</div>
      </div>
      <img src="@/assets/Mobile/images/solution/o2o01.png" alt="">
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title white">线上线下无缝打通</div>
      </div>
      <div class="content">
        <div class="item">
          <div class="sk-mobile-title">
            <div class="title">移动商城</div>
            <div class="sub-title">APP、小程序、公众号</div>
          </div>
          <img class="image01" src="@/assets/Mobile/images/solution/o2o02.png" alt="">
        </div>
        <div class="item">
          <div class="sk-mobile-title">
            <div class="title">PC商城</div>
          </div>
          <img class="image02" src="@/assets/Mobile/images/solution/o2o03.png" alt="">
        </div>
        <div class="item">
          <div class="sk-mobile-title">
            <div class="title">门店智能设备</div>
          </div>
          <img class="image03" src="@/assets/Mobile/images/solution/o2o04.png" alt="">
        </div>
      </div>
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">线上线下互通互联</div>
      </div>
      <img src="@/assets/Mobile/images/solution/o2o05.png" alt="">
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">全渠道数字化</div>
      </div>
      <div class="content">
        <img src="@/assets/Mobile/images/solution/o2o06.png" alt="">
        <img src="@/assets/Mobile/images/solution/o2o07.png" alt="">
        <img src="@/assets/Mobile/images/solution/o2o08.png" alt="">
        <img src="@/assets/Mobile/images/solution/o2o09.png" alt="">
      </div>
    </div>
    <div class="block05">
      <div class="sk-mobile-title">
        <div class="sk-mobile-title">
          <div class="title">多业态支持</div>
          <div class="sub-title">不管是单店或者连锁店模式，都可完美支持</div>
        </div>
      </div>
      <div class="content">
        <img src="@/assets/Mobile/images/solution/o2o10.png" alt="">
        <img src="@/assets/Mobile/images/solution/o2o11.png" alt="">
        <img src="@/assets/Mobile/images/solution/o2o12.png" alt="">
      </div>
    </div>
    <div class="block06">
      <div class="sk-mobile-title">
        <div class="title">定制流程</div>
      </div>
      <img src="@/assets/Mobile/images/solution/brand02.png" alt="">
    </div>
    <Case title="O2O定制" />
    <ContactForm info-sources="O2O定制" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import Case from '@/Mobile/Mobilecom/Case'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'

export default {
  metaInfo: metaInfo.O2OCustom,
  components: {
    Case,
    ContactForm
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  img {
    width: 333px;
    margin: 15px 0 32px 0;
  }
}
.block02 {
  background-color: #375ee8;
  overflow: hidden;
  .white {
    color: #fff;
  }
  .content {
    margin: 29px 16px 25px 16px;
    background-color: #fff;
    img {
      margin: 15px 0;
    }
    .image01 {
      width: 125px;
    }
    .image02 {
      width: 290px;
    }
    .image03 {
      width: 247px;
    }
  }
}
.block03 {
  background-color: #F9F9F9;
  img {
    width: 336px;
    margin: 26px 0;
  }
}
.block04 {
  .content {
    padding-top: 20px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    img {
      width: 162px;
      height: 283px;
      margin: 15px 10px;
    }
  }
}
.block05 {
  background-color: #F6FBFF;
  .content {
    padding: 29px 0 19px 0;
    display: flex;
    width: 375px;
    justify-content: space-between;
    img {
      width: 125px;
      height: 91px;
    }
  }
}
.block06 {
  img {
    margin: 16px 0 24px 0;
    width: 341px;
  }
}
</style>
